// extracted by mini-css-extract-plugin
export var dateby = "topper-module--dateby--frZoJ";
export var dek = "topper-module--dek--6fR-t";
export var figure = "topper-module--figure--ZzMX9";
export var header = "topper-module--header--3jsFQ";
export var hed = "topper-module--hed--kcsDF";
export var illoWrapper = "topper-module--illo-wrapper--U19FR";
export var illoWrapperOld = "topper-module--illo-wrapper-old--bazoq";
export var image = "topper-module--image--MTLLF";
export var kicker = "topper-module--kicker--YHIWC";
export var textContainer = "topper-module--text-container--YZnr7";
export var topcap = "topper-module--topcap--N3k-5";
export var topcred = "topper-module--topcred--sE05c";
export var viz = "topper-module--viz--+hGlb";